import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';

import { Box, Button, Icon } from '@lucidhq/lucidium';

import { useFetchForcedExposureCreativeDownload } from '~/components/Shared/hooks/useFetchForcedExposureCreatives';

type PreviewDialogProps = {
  campaignId?: string;
  creativeId: string;
  children: ({ handleToggle }: { handleToggle: () => void }) => React.ReactNode;
};

export const PreviewDialog = ({
  campaignId,
  creativeId,
  children
}: PreviewDialogProps) => {
  const [isOpen, setIsOpen] = useState<boolean>();

  const { data } = useFetchForcedExposureCreativeDownload({
    campaignId,
    creativeId,
    isEnabled: isOpen
  });

  const isImage = /\.(jpe?g|png|gif|webp)$/i.test(data?.file_name ?? '');
  const isVideo = /\.(mp4|mov|mkv|avi|webm)$/i.test(data?.file_name ?? '');

  return (
    <>
      {children({ handleToggle: () => setIsOpen(prev => !prev) })}
      {isOpen && data?.download_url && (
        <Box
          lss={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // @ts-ignore
            zIndex: 1000
          }}
          onClick={() => setIsOpen(false)}
        >
          <Button
            data-testid="close-preview-btn"
            emphasis="low"
            onClick={e => {
              e.stopPropagation();
              setIsOpen(false);
            }}
            lss={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              // @ts-ignore
              zIndex: 1001
            }}
          >
            <Icon size={24} as={MdClose} />
          </Button>
          <Box
            onClick={e => e.stopPropagation()}
            lss={{
              maxWidth: '90%',
              maxHeight: '90%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {isImage && (
              <img
                src={data.download_url}
                alt={data.display_name}
                style={{
                  maxWidth: '90vw',
                  maxHeight: '90vh',
                  objectFit: 'contain',
                  display: 'block'
                }}
              />
            )}
            {isVideo && (
              <video
                controls
                style={{
                  maxWidth: '90vw',
                  maxHeight: '90vh',
                  objectFit: 'contain',
                  display: 'block'
                }}
              >
                <source src={data.download_url} />
              </video>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};
